<template>
    <div class="section">
        <div class="container has-text-centered">
            <p class="is-subtitle">A TU SERVICIO</p>
            <p class="is-title">Nuestro equipo de expertos</p>
        </div>
        <div class="container is-flex is-flex-wrap-wrap is-justify-content-center">
            <div class="is-team-box is-teamate-1 is-flex is-align-items-flex-end" @mouseover="hoverAlexis = true"
                @mouseleave="hoverAlexis = false">
                <div class="is-team-box-content">
                    <p class="is-teamate-name">Alexis Piña</p>
                    <p class="is-teamate-name">Aquino</p>
                    <p class="is-teamate-title">Sr. Developer Python / Director de Tecnología</p>
                    <p v-if="hoverAlexis" class="is-teamate-description mt-2">
                        Arquitecto de soluciones robustas con experiencia en sistemas distribuidos y automatización.
                    </p>
                </div>
            </div>

            <div class="is-team-box is-teamate-2 is-flex is-align-items-flex-end" @mouseover="hoverPavel = true"
                @mouseleave="hoverPavel = false">
                <div class="is-team-box-content">
                    <p class="is-teamate-name">Pavel Solano</p>
                    <p class="is-teamate-name">García</p>
                    <p class="is-teamate-title">Director de Operaciones / Sr. Management</p>
                    <p v-if="hoverPavel" class="is-teamate-description mt-2">
                        Líder estratégico con foco en eficiencia operativa y gestión de equipos multidisciplinarios.
                    </p>
                </div>
            </div>

            <div class="is-team-box is-teamate-3 is-flex is-align-items-flex-end" @mouseover="hoverFernando = true"
                @mouseleave="hoverFernando = false">
                <div class="is-team-box-content">
                    <p class="is-teamate-name">Fernando Martinez</p>
                    <p class="is-teamate-name">Rodriguez</p>
                    <p class="is-teamate-title">Sr. Developer Frontend (Angular & React)</p>
                    <p v-if="hoverFernando" class="is-teamate-description mt-2">
                        Experto en crear interfaces web modernas, escalables y accesibles.
                    </p>
                </div>
            </div>

            <div class="is-team-box is-teamate-4 is-flex is-align-items-flex-end" @mouseover="hoverCarlosSanchez = true"
                @mouseleave="hoverCarlosSanchez = false">
                <div class="is-team-box-content">
                    <p class="is-teamate-name">Carlos Sánchez</p>
                    <p class="is-teamate-name">Antonio</p>
                    <p class="is-teamate-title">Director Automatización Inteligente / Sr. Data Sciences</p>
                    <p v-if="hoverCarlosSanchez" class="is-teamate-description mt-2">
                        Implementa IA y análisis avanzado de datos para procesos inteligentes.
                    </p>
                </div>
            </div>

            <div class="is-team-box is-teamate-5 is-flex is-align-items-flex-end" @mouseover="hoverCarlosDiaz = true"
                @mouseleave="hoverCarlosDiaz = false">
                <div class="is-team-box-content">
                    <p class="is-teamate-name">Carlos Manuel</p>
                    <p class="is-teamate-name">Díaz Ortiz</p>
                    <p class="is-teamate-title">Sr. Frontend Developer</p>
                    <p v-if="hoverCarlosDiaz" class="is-teamate-description mt-2">
                        Desarrollador frontend enfocado en experiencia, rendimiento y accesibilidad.
                    </p>
                </div>
            </div>

            <div class="is-team-box is-teamate-6 is-flex is-align-items-flex-end" @mouseover="hoverKristinne = true"
                @mouseleave="hoverKristinne = false">
                <div class="is-team-box-content">
                    <p class="is-teamate-name">Jorge</p>
                    <p class="is-teamate-name">Eslava</p>
                    <p class="is-teamate-title">Semi Sr. React, Astro</p>
                    <p v-if="hoverKristinne" class="is-teamate-description mt-2">
                        Desarrollador frontend con experiencia en React y Astro, creando interfaces web dinámicas y
                        eficientes.
                    </p>
                </div>
            </div>

            <div class="is-team-box is-teamate-7 is-flex is-align-items-flex-end" @mouseover="hoverKristinne = true"
                @mouseleave="hoverKristinne = false">
                <div class="is-team-box-content">
                    <p class="is-teamate-name">Kristinne</p>
                    <p class="is-teamate-name">Barrera</p>
                    <p class="is-teamate-title">Sr. UX/UI Designer</p>
                    <p v-if="hoverKristinne" class="is-teamate-description mt-2">
                        Experta en diseño de experiencias digitales limpias, funcionales y centradas en el usuario.
                    </p>
                </div>
            </div>

            <div class="is-team-box is-teamate-8 is-flex is-align-items-flex-end" @mouseover="hoverKristinne = true"
                @mouseleave="hoverKristinne = false">
                <div class="is-team-box-content">
                    <p class="is-teamate-name">Ximena</p>
                    <p class="is-teamate-name">Neri</p>
                    <p class="is-teamate-title">Jr Management</p>
                    <p v-if="hoverKristinne" class="is-teamate-description mt-2">
                        Coordinadora de proyectos con habilidades en gestión de equipos y comunicación efectiva.
                    </p>
                </div>
            </div>

            <div class="is-team-box is-teamate-9 is-flex is-align-items-flex-end" @mouseover="hoverKristinne = true"
                @mouseleave="hoverKristinne = false">
                <div class="is-team-box-content">
                    <p class="is-teamate-name">Karla</p>
                    <p class="is-teamate-name">Aguirre</p>
                    <p class="is-teamate-title">Sr. UX/UI</p>
                    <p v-if="hoverKristinne" class="is-teamate-description mt-2">
                        Experta en diseño UX/UI con un enfoque en la usabilidad y la estética visual.
                    </p>
                </div>
            </div>

            <div class="is-team-box is-teamate-10 is-flex is-align-items-flex-end" @mouseover="hoverKristinne = true"
                @mouseleave="hoverKristinne = false">
                <div class="is-team-box-content">
                    <p class="is-teamate-name">Hector Daniel </p>
                    <p class="is-teamate-name">Moreno</p>
                    <p class="is-teamate-title">QA tester Sr.</p>
                    <p v-if="hoverKristinne" class="is-teamate-description mt-2">
                        Especialista en pruebas de calidad, asegurando que los productos cumplan con los estándares más
                        altos.
                    </p>
                </div>
            </div>

        </div>
    </div>
</template>


<script>
export default {
    name: "AboutUsTeam",
    data() {
        return {
            hoverFirst: false,
            hoverSecond: false,
            hoverThird: false
        }
    }
}
</script>

<style scoped>
.section .container {
    margin-bottom: 50px;
}

.is-subtitle {
    color: var(--Blue, #2489CA);
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 5.4px;
}

.is-title {
    font-size: 28px;
    font-weight: 600;
}

@media only screen and (max-width: 768px) {
    .is-subtitle {
        font-size: 12px;
        letter-spacing: 3.6px;
    }

    .is-title {
        font-size: 24px;
    }
}

.is-team-box {
    height: 330px;
    width: 250px;
    background-size: cover;
    cursor: pointer;
}

.is-teamate-1 {
    background-image: url('@/assets/img/teamate-1.jpeg');
    background-position: center;
}

.is-teamate-2 {
    background-image: url('@/assets/img/teamate-2.jpeg');
    background-position: center;
}

.is-teamate-3 {
    background-image: url('@/assets/img/teamate-3.jpeg');
    background-position: center;
}

.is-teamate-4 {
    background-image: url('@/assets/img/teamate-4.jpeg');
    background-position: center;
}

.is-teamate-5 {
    background-image: url('@/assets/img/teamate-5.png');
}

.is-teamate-6 {
    background-image: url('@/assets/img/teamate-6.jpeg');
}

.is-teamate-7 {
    background-image: url('@/assets/img/teamate-7.png');
}

.is-teamate-8 {
    background-image: url('@/assets/img/teamate-8.jpeg');
}

.is-teamate-9 {
    background-image: url('@/assets/img/teamate-9.jpeg');
}

.is-teamate-10 {
    background-image: url('@/assets/img/teamate-10.jpeg');
}

.is-team-box-content {
    margin: 20px;
    padding: 5px;
    border-left-style: solid;
    border-left-width: 1px;
    border-left-color: #15D9FD;
}

.is-teamate-name {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
}

.is-teamate-title {
    color: var(--Light-Blue, #15D9FD);
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 180%;
}

.is-teamate-description {
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 180%;
}
</style>